var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsercircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0929 37.9828C31.5643 33.7027 27.9151 30.3893 23.492 30.3893H19.1587C14.7356 30.3893 11.0864 33.7027 10.5578 37.9828M32.0929 37.9828C37.3557 34.4907 40.8253 28.5119 40.8253 21.7227C40.8253 10.9531 32.0949 2.22266 21.3253 2.22266C10.5558 2.22266 1.82532 10.9531 1.82532 21.7227C1.82532 28.5119 5.29494 34.4907 10.5578 37.9828M32.0929 37.9828C29.0074 40.0301 25.3056 41.2227 21.3253 41.2227C17.345 41.2227 13.6432 40.0301 10.5578 37.9828M27.8253 17.3893C27.8253 20.9792 24.9152 23.8893 21.3253 23.8893C17.7355 23.8893 14.8253 20.9792 14.8253 17.3893C14.8253 13.7995 17.7355 10.8893 21.3253 10.8893C24.9152 10.8893 27.8253 13.7995 27.8253 17.3893Z",
    stroke: "#5A6ACF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsercircle);
export default __webpack_public_path__ + "static/media/usercircle.6a578a3fa6d01ca0a58a1ad9e61c857a.svg";
export { ForwardRef as ReactComponent };